import { request } from './shared';

export function sendEmailNotification(messageDetails) {
  return request({
    data: messageDetails,
    method: 'POST',
    url: '/click',
  });
}
